<template>
  <v-navigation-drawer
    :value="open"
    :permanent="$vuetify.breakpoint.lgAndUp"
    app
    width="280px"
    class="py-4"
    :color="$vuetify.theme.dark ? 'grey darken-4' : 'white'"
    @input="$emit('drawerChange', $event)"
  >
    <v-img
      class="mx-auto"
      width="185px"
      src="/assets/ekpa-logo-text-transparent.png"
      :style="{
        filter: $vuetify.theme.dark ? 'invert(0.85) brightness(0.9)' : 'none'
      }"
    />

    <v-divider class="my-6" />

    <v-tabs
      vertical
      :background-color="$vuetify.theme.dark ? 'transparent' : 'transparent'"
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.to"
        :to="tab.to"
        class="justify-start ml-0 nav-tab"
      >
        <v-icon class="mr-4">
          {{ tab.icon }}
        </v-icon>

        <span class="text-body-1 font-weight-medium text-capitalize">
          {{ tab.text }}
        </span>
      </v-tab>
    </v-tabs>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tabs: [
        {
          to: '/requests',
          text: 'Αιτήσεις',
          icon: 'mdi-clipboard-text-outline'
        },
        {
          to: '/devices',
          text: 'Τηλεφωνικές συσκευές',
          icon: 'mdi-deskphone'
        },
        {
          to: '/number-pools',
          text: 'Αριθμοδοτικοί πόροι',
          icon: 'mdi-sim-outline'
        },
        {
          to: '/cucm-groups',
          text: 'Ευκολίες',
          icon: 'mdi-list-box-outline'
        },
        {
          to: '/warehouse',
          text: 'Αποθήκες',
          icon: 'mdi-warehouse'
        },
        {
          to: '/models',
          text: 'Μοντέλα',
          icon: 'mdi-phone-log'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-tab {
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}

.theme--dark .nav-tab:hover {
  background-color: rgba(255, 255, 255, 0.08);
}
</style>
